<template>
  <div class="container">
    <div v-if="!isMobile" class="pc-wrapper">
      <div class="relations-wrapper">
        <div class="relations-banner">
          <img src="https://img.i2soft.net/i2official-web/assets/images/relations/gov_back.png" />
          <div class="relations-banner-text"></div>
        </div>
        <div class="announcement-wrapper">
          <div class="announcement-container">
            <div class="announcement-nav">
              <a @click.prevent="jump('anc')" :class="{ active: staic === 'anc' }">公司公告</a>
              <a @click.prevent="jump('gov')" :class="{ active: staic === 'gov' }">公司治理</a>
              <a @click.prevent="jump('acv')" :class="{ active: staic === 'acv' }">业绩报告</a>
              <a :class="{ active: staic === 'ser' }">投资者服务</a>
            </div>
          </div>
        </div>
        <div class="map-wrapper">
          <div class="section-content">
            <div class="inner-tit center gray">
              <WaveTitle style="margin-top: 20px" title="投资者服务" subhead="Articles of constitution"></WaveTitle>
            </div>
            <div class="service-container">
              <div class="service-left">
                <div class="service-title">联系我们</div>
                <div class="service-contact">
                  <div class="contact">
                    <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/platformSevice.png" />
                    <div class="contact-right">
                      <div class="contact-label">投资者互动平台</div>
                      <div class="contact-value">
                        <a href="https://rs.p5w.net/investor/920799" target="_blank">
                          <span>立即跳转</span>
                          <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/polygon.png" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="contact">
                    <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/phoneSevice.png" />
                    <div class="contact-right">
                      <div class="contact-label">投资者热线</div>
                      <div class="contact-value">021-68816718</div>
                    </div>
                  </div>
                  <div class="contact">
                    <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/emailService.png" />
                    <div class="contact-right">
                      <div class="contact-label">投资者邮箱</div>
                      <div class="contact-value">public@i2finance.net</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="service-right">
                <img src="https://img.i2soft.net/i2official-web/v2/assets/images/relations/serviceBg.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isMobile } from "@/utils/index";
  import $ from "jquery";
  import WaveTitle from "@/components/WaveTitle";

  export default {
    components: {
      WaveTitle,
    },
    data() {
      return {
        isMobile: false,
        annualList: [],
        InterimList: [],
        QuarterlyList: [],
        datas: [],
        shareholderList: [],
        active: "",
        block: "",
        staic: "",
        query_type: "",
        location: "",
      };
    },
    created() {
      this.getachievent();
      this.query_type = this.$route.query.category;
      this.location = this.$route.query.location;
      this.pg_change(this.query_type);
      this.func(this.location);
    },
    mounted() {
      this.isMobile = isMobile();
      window.addEventListener("scroll", this.getScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.getScroll);
    },
    methods: {
      jump(type) {
        const routes = {
          anc: "/Announce",
          acv: "/Achievement",
          gov: "/government",
        };
        if (routes[type]) {
          this.$router.push({ path: routes[type], query: { category: type } });
        }
      },
      pg_change(type) {
        this.staic = type;
      },
      getachievent() {
        this.$axios.get("/parameter/shareholderList").then((res) => {
          this.shareholderList = res.data.data;
        });
      },
      func(c) {
        if (!c) {
          this.active = "director";
          this.block = "director";
          window.scrollTo(0, 540);
          return;
        }

        const hash = window.location.hash;
        const index = hash.lastIndexOf("#");
        let id = null;

        if (index !== -1) {
          id = hash.substring(index + 1);
        }

        setTimeout(() => {
          if (id && document.getElementById(id)) {
            $("html, body").animate({ scrollTop: $(document.getElementById(id)).offset().top - 43 }, 500);
          }
        }, 0);

        if (c !== "consti") {
          this.active = c;
          this.block = c;
        } else {
          this.active = "director";
          this.block = "director";
        }
      },
      getScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if (scrollTop >= 70) {
          this.$store.commit("TO_AfterScroll");
        } else {
          this.$store.commit("TO_AfterScroll_false");
        }
      },
      nowLink() {
        window.location.href = "https://ir.p5w.net/c/920799.shtml";
      },
    },
  };
</script>

<style lang="less" scoped>
  * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .relations-wrapper {
    background-color: #ffffff;

    .relations-banner {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        height: auto;
      }

      .relations-banner-text {
        position: absolute;
        top: 45%;
        left: 45%;
        display: flex;
        flex-direction: column;
      }
    }

    .announcement-wrapper {
      margin-top: -6px;
      background-color: #f4f0d7;
      padding: 0 20px;
      display: flex;
      justify-content: center;

      .announcement-container {
        width: 75%;

        .announcement-nav {
          margin-right: 25px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          column-gap: 31px;

          a {
            padding: 20px 0;
            text-decoration: none;
            color: #000000;
            font-size: 15px;
            cursor: pointer;
          }

          a:hover,
          .active {
            color: #f49a42;
          }
        }
      }
    }

    .map-wrapper {
      .section-content {
        width: 80%;
        margin: 0 auto;

        .service-container {
          display: flex;
          flex-direction: row;
          column-gap: 20px;
          justify-content: center;
          align-items: flex-end;
          padding-bottom: 5rem;

          .service-left {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            row-gap: 50px;

            .service-title {
              font-size: 52px;
              font-weight: 500;
              color: #001f34;
              text-align: left;
              margin: 20px 0;
            }

            .service-contact {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              row-gap: 30px;

              .contact {
                padding: 50px 40px;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                row-gap: 10px;
                column-gap: 40px;
                background-color: #fafafa;

                img:first-child {
                  width: 45px;
                  min-width: 45px;
                  height: 45px;
                }

                .contact-right {
                  display: flex;
                  flex-direction: column;
                  row-gap: 2rem;
                  align-items: flex-start;

                  .contact-label {
                    font-size: 26px;
                    color: #001f34;
                    text-align: left;
                  }

                  .contact-value {
                    text-align: left;
                    cursor: pointer;
                    font-size: 18px;
                    color: #727272;

                    a {
                      color: #727272;
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: flex-start;
                      column-gap: 15px;
                    }
                    a:hover {
                      color: #f49a42;
                    }

                    img {
                      width: 14px;
                      min-width: 14px;
                    }
                  }
                }
              }
            }
          }

          .service-right {
            flex: 1;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>
